<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<mat-dialog-content>
  <div class="control-item-component">
    <mat-card>
      <mat-card-title>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Generated Password</h2>
      </mat-card-title>
      <mat-card-content>

        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >
          <div class="message">
            New password for user is:
            <input type="text" [value]="password" readonly/>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="text-center col-xs-12">
  <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Close</button>
</mat-dialog-actions>
